<template>
  <div class="pa-0">
    <div class="xcard pb-0" xstyle="position:relative">
      <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
      <h3 class="text-center mt-0 mb-0" style="margin-top: 0">Inscripciones al programa:</h3>
      <p class="h4 text-center text-primary" style="margin-bottom: 0">
        <span v-if="programa_rest">{{ programa_rest.codigo }}</span> {{ pro }}
      </p>

      <ContraGOup ref="refContraGOup" />
      <ContraCCA_cursos ref="refContraCCA_cursos" />

      <div class="row mb-0 pb-0">
        <div class="col-sm-3 mb-0 pb-0">
          <input type="text" class="form-control input-sm" style="max-width: 200px" v-model="buscar"
            placeholder="Buscar participante..." />
        </div>

        <div class="col-sm-3 mb-0 pb-0">
          <div class="form-group mb-0 pb-0">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Estado:</div>
              <select v-model="buscar" class="form-control">
                <option :value="'Pre inscrito'">Pre inscrito</option>
                <option :value="'Inscrito'">Inscrito</option>
                <!-- <option :value="'inscrito+certificacion'">inscrito+certificacion</option>
                <option :value="'retirado'">retirado</option>
                <option :value="'cambiado'">cambiado</option>
                <option :value="'congelado'">congelado</option>
                <option :value="'pagado-inscripcion'">pagado-inscripcion</option>
                <option :value="'pagado'">pagado</option>
                <option :value="'no puede pagar'">no puede pagar</option>
                <option :value="'Generar plan'">Generar plan</option>
                <option :value="'Por Generar Plan'">Por Generar Plan</option> -->
                <option :value="''">Todos</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-sm-3 mb-0 pb-0">
          <div class="form-group mb-0 pb-0">
            <div class="input-group input-group-sm">
              <div class="input-group-addon">Asesor:</div>
              <select v-model="buscar" class="form-control">
                <option v-for="(a, indx) in asesores" :key="indx" :value="a.nombre">{{ a.nombre }}</option>
                <option :value="''">Todos</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-3 mb-0 pb-0">
          <!-- <button class="btn btn-sm btn-success" @click="asignarcobradorprog()">Asignar Cobrador</button>
                    <button class="btn btn-sm btn-success" @click="asignarcobradorprogins()">Definir Cobrador</button> -->
        </div>
      </div>
      {{ formatCode() }} <small>{{ getFase(programa.fase) }}</small>

      <button :disabled="$store.state.isonlyread" v-show="inscripciones.length > 0 && is_user_of_sede"
        class="btn btn-sm btn-link" @click="tableToExcel('table', 'Lorem Table')">
        <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL
      </button>
      <button v-if="
        $store.state.CARGO.id != 11 &&
        $store.state.CARGO.id != 12 &&
        $store.state.CARGO.id != 13 &&
        $store.state.CARGO.id != 14 &&
        $store.state.CARGO.id != 15 &&
        $store.state.CARGO.id != 25
      " :disabled="$store.state.isonlyread" v-show="inscripciones.length > 0" title="Generar Certificado"
        class="btn btn-sm btn-link" @click="generarCertificados(programita)">
        <span class="glyphicon glyphicon-book"></span> CERTIFICADOS
      </button>
      <button v-if="
        $store.state.CARGO.id != 11 &&
        $store.state.CARGO.id != 12 &&
        $store.state.CARGO.id != 13 &&
        $store.state.CARGO.id != 14 &&
        $store.state.CARGO.id != 15 &&
        $store.state.CARGO.id != 25
      " v-show="inscripciones.length > 0 && is_user_of_sede"
        :disabled="$store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25"
        title="Ir a asignaciones" class="btn btn-sm btn-link" @click="irasignaciones(programita)">
        <span class="glyphicon glyphicon-book"></span> Asignaciones
      </button>
      <button v-if="
        $store.state.CARGO.id != 11 &&
        $store.state.CARGO.id != 12 &&
        $store.state.CARGO.id != 13 &&
        $store.state.CARGO.id != 14 &&
        $store.state.CARGO.id != 15 &&
        $store.state.CARGO.id != 25
      " v-show="inscripciones.length > 0 && is_user_of_sede"
        :disabled="$store.state.CARGO.id == 11 || $store.state.CARGO.id == 13" title="Ir a calificaciones"
        class="btn btn-sm btn-link" @click="iracalificaciones(programita)">
        <span class="glyphicon glyphicon-book"></span> Calificaciones
      </button>
      <button v-if="$store.state.CARGO.id != 11 && $store.state.CARGO.id != 12 && $store.state.CARGO.id != 13"
        v-show="inscripciones.length > 0 && is_user_of_sede" :disabled="$store.state.isonlyread" data-toggle="modal"
        data-target="#modalnotiall" title="Notificar Deudores" class="btn btn-sm btn-link"
        @click="enviarnotificacionall()">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#1177d1" class="bi bi-chat-dots"
          viewBox="0 0 16 16">
          <path
            d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
          <path
            d="M2.165 15.803l.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z" />
        </svg>
        Notificar Deudores
      </button>

      <v-btn v-if="$store.state.CARGO.id == 1" small text @click="$router.push('/estados_tit')">
        estados titulacion</v-btn>

      <p class="my-0 red--text">
        <small>
          {{
            is_user_of_sede
              ? ''
              : 'No perteneces a esta sede, algunos datos no seran visibles por motivos de seguridad.'
          }}
        </small>
      </p>

      <div class="table-responsive" style="position: relative">
        <p class="text-primary" v-html="msg"></p>
        <label v-show="inscripciones.length && is_user_of_sede">
          <input type="checkbox" v-model="contraercolumnas" /> Contraer columnas
          <small>(Ocultar las columnas no necesarias)</small>
        </label>

        <span v-if="filtro_size" class="blue--text">
          <br /><b>{{ filtro_size }} resultados.</b>
        </span>

        <table ref="table" class="table table-condensed table-striped table-hover tablita"
          summary="lorem ipsum sit amet" rules="groups" frame="hsides" id="midatatable">
          <caption v-show="false">
            Reporte de Inscripciones al programa:
            {{
              pro
            }}
          </caption>
          <thead style="background: #196391">
            <tr>
              <th class="white--text">#</th>
              <th class="white--text" v-if="!contraercolumnas" style="min-width: 100px">Apellido 1</th>
              <th class="white--text" v-if="!contraercolumnas" style="min-width: 100px">Apellido 2</th>
              <th class="white--text" v-if="!contraercolumnas" style="min-width: 160px">Nombres</th>
              <th class="white--text" v-if="contraercolumnas" style="min-width: 160px">Estudiante</th>
              <th class="white--text" style="min-width: 95px">Documento</th>
              <th class="white--text" v-show="!contraercolumnas">Correo</th>
              <th class="white--text" v-show="!contraercolumnas">Profesiones</th>
              <th class="white--text" v-show="is_user_of_sede">Telefono</th>
              <th class="white--text" v-show="false" vv-if="!contraercolumnas">Login</th>
              <th class="white--text" v-show="false" vv-if="!contraercolumnas">Clave</th>

              <!-- <th class="white--text" v-show="false">Sede</th> -->
              <!-- <th class="white--text" v-show="false">Profesion</th> -->
              <th class="white--text" v-show="false">Observacion</th>
              <th class="white--text" v-show="false">Universidad</th>
              <th class="white--text" v-show="false">Genero</th>

              <th class="white--text" v-if="!contraercolumnas" style="min-width: 80px">Inscrito</th>
              <th class="white--text" v-if="!contraercolumnas" style="min-width: 120px">Asesor</th>
              <th class="white--text" v-if="!contraercolumnas" style="min-width: 80px">Asesor Tel.</th>

              <th class="white--text" v-show="false">Fecha nacimiento</th>
              <th class="white--text" v-show="false">Estado civil</th>
              <th class="white--text" v-show="false">Ciudad</th>
              <th class="white--text" v-show="false">Direccion</th>

              <th class="white--text">Estado</th>
              <th class="white--text">Estado Administrativo</th>
              <th class="white--text">Estado Academico</th>
              <th class="white--text">Estado de Titulaciones</th>
              <th class="white--text">Es Modular</th>
              <th class="white--text">Estado Cartera</th>
              <th class="white--text">Estado Inscrito Universidad</th>
              <th class="white--text">Codigo Programa Universidad</th>
              <th class="white--text">Doc. Respaldo</th>
              <th class="white--text" xstyle="min-width: 345px" v-if="is_user_of_sede">Opciones</th>
              <template v-if="programa_rest">
                <th v-if="!contraercolumnas && programa_rest.plataforma_id && programa_rest.categoria_id"
                  style="min-width: 150px">
                  Moodle
                </th>
              </template>
            </tr>
          </thead>

          <tbody>
            <tr v-bind:key="ins.id" v-for="(ins, ind) in inscripciones">
              <td :title="'ID inscripcion: ' + ins.id">{{ ind + 1 }}</td>
              <td v-if="!contraercolumnas" :title="'ID Estudiante: ' + ins.estudiante.id">
                {{ parseApellidos(ins.estudiante, 1) }}
              </td>
              <td v-if="!contraercolumnas" :title="'ID Estudiante: ' + ins.estudiante.id">
                {{ parseApellidos(ins.estudiante, 2) }}
              </td>
              <td v-if="!contraercolumnas" :title="'ID Estudiante: ' + ins.estudiante.id">
                {{ ins.estudiante.nombres }}
              </td>
              <td v-if="contraercolumnas" @click="whatsappconta(parseTelefono(ins.estudiante), ins.estudiante)">
                {{ parseEstudiante(ins.estudiante) }}
              </td>
              <td :title="'ID Estudiante: ' + ins.estudiante.id">{{ parseDoc(ins.estudiante) }}</td>

              <td v-show="!contraercolumnas">
                <a title="Enviar datos de acceso." href="#" data-toggle="modal" data-target="#modalc"
                  @click="enviarCorreoDefault(ins)">
                  {{ parseCorreo(ins.estudiante) }}
                </a>
              </td>
              <td v-show="!contraercolumnas">
                <p class="pa-0 ma-0" v-for="(p, i) in getProfesiones(ins.estudiante)" :key="i">
                  - {{ p.nombre }}
                </p>
              </td>

              <td v-show="is_user_of_sede">
                <a title="Abrir Whatsapp" href="#"
                  @click="whatsapp(parseTelefono(ins.estudiante), programita, ins.estudiante)">
                  {{ parseTelefono(ins.estudiante) }}
                </a>
              </td>
              <td v-show="false" vv-if="!contraercolumnas">{{ parseLogin(ins.estudiante) }}</td>
              <td v-show="false" vv-if="!contraercolumnas">{{ parseClave(ins.estudiante) }}</td>

              <!-- <td v-show="false">{{ parseSede(ins.programa) }}</td> -->
              <!-- <td v-show="false">{{ getProfesion(ins.estudiante.profesiones) }}</td> -->
              <td v-show="false">{{ getObservacion(ins.observaciones) }}</td>
              <td v-show="false">{{ getInstitucion(ins.estudiante.institucion) }}</td>
              <td v-show="false">{{ getGenero(ins.estudiante) }}</td>
              <td v-if="!contraercolumnas">
                <small>{{ parseFecha(ins.fecha_registro) }}</small>
              </td>
              <td v-if="!contraercolumnas" @click="openDialogChangeAsesor(ins)">{{ parseEstudiante(ins.asesor) }}</td>
              <td v-if="!contraercolumnas">{{ ins.asesor.telefono1 }}</td>

              <td v-show="false">{{ ins.estudiante.fecha_nac + '' }}</td>
              <td v-show="false">{{ ins.estudiante.est_civil }}</td>
              <td v-show="false">{{ parseciudad(ins.estudiante.ciudad) }}</td>
              <td v-show="false">{{ ins.estudiante.domicilio }}</td>

              <td :style="parseInsColor(ins.estado_ins)" title="Asterisco con certificado" class="manito"
                @click="cambiarestadoins(ins)">
                {{ parseIns(ins.estado_ins, ins.certificado_id) }}
              </td>
              <td @click="cambiarestadoAdministrativo(ins)">
                <v-chip small :color="getEstadoAdministrativoColor(ins.estado_administrativo_id)" dark>
                  {{ parseInsAdministrativo(ins.estado_administrativo_id) }}
                </v-chip>
              </td>

              <!-- <td 
                @click="cambiarestadoAdministrativo(ins)">
                {{ parseIns(ins.estado_ins, ins.certificado_id) }}
              </td> -->

              <td v-if="isdna" style="overflow: visible;">
                <!-- <vue-select
                v-model="ins.xestado_academico"               
                placeholder="Est Academico"                
                :options="treeData"
                label="nombre"
                class="custom-select"
                :searchable="false"
                :selectable="(option) => option.selectable"                
                :reduce="(option) => option.id">
                
                <template v-slot:option="option">
                  <span :style="{ marginLeft: `${option.level * 20}px` }" v-html="option.nombre"></span>
                </template>
                <template v-slot:single-label="option">
    {{ option.nombre }}
  </template>:disabled="ins.estado_ins == 0 && !isdna"

              </vue-select> -->
                <v-select v-model="ins.xestado_academico" :items="treeData" :disabled="ins.estado_ins === 0"
                  :label="'Estado: ' + (ins?.xestado_academico?.nombre_padre?.split('/')[0] || '')" dense hide-details
                  persistent-hint small-chips return-object @change="guardarEstadoAcademico(ins)">
                  <template v-slot:selection="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" class="ma-0" dense
                          :color="item?.nombre_padre.split('/')[0].trim() === 'Vigente' ? 'green' : 'red'"
                          style="width: 100%" label outlined block>
                          {{ item?.nombre }}
                        </v-chip>
                      </template>
                      <span>{{ item?.nombre_padre }} </span>
                    </v-tooltip>


                  </template>

                  <template v-slot:item="{ item }">
                    <span
                      :style="{ marginLeft: `${item?.level * 20}px !important`, cursor: item.disabled ? 'not-allowed !important' : 'pointer !important' }">
                      <!-- :style="{  marginLeft: `${item?.level * 20}px !important`}" <v-chip class="mx-0 my-1" :color="item.disabled?'red':'green'" :style="{ cursor: item.disabled?'not-allowed !important': 'pointer !important' }"  label outlined block>
                      {{ item.nombre }}
                    </v-chip> -->
                      {{ item.nombre }}
                    </span>
                  </template>
                </v-select>
                <!-- <v-select
                  v-model="ins.xestado_academico"
                  :items="treeData"
                  label="Estado:"
                  dense
                  hide-details
                  persistent-hint
                  small-chips
                  return-object
                  @change="guardarEstadoAcademico(ins)">
                  <template v-slot:selection="{ item }">
                    <v-chip class="ma-0" dense :color="item.color" style="width: 100%" label outlined block>
                      {{ item.nombre }}
                    </v-chip>
                  </template>

                  <template v-slot:item="{ item }"> 
                    <v-chip class="mx-0 my-1" :color="item.color" style="width: 100%" label outlined block>
                      {{ item.nombre }}
                    </v-chip>
                  </template>
                   
                </v-select> -->
                <!-- <v-combobox
      v-model="selected"
      :items="treeData"
      item-text="nombre"
      item-value="id"
      return-object
      outlined
      dense
    >
      <template v-slot:item="{ item }">
        <v-list-item>
          <v-list-item-title
            :style="{ marginLeft: `${item.level * 20}px` }"
          >
            {{ item.nombre }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-combobox> -->
                <!-- <v-combobox
      v-model="selected"
      :items="treeData"
      item-text="nombre"
      item-value="id"
      return-object
      outlined
      dense
    >
      <template v-slot:item="{ item }">
        <v-list-item>
          <v-list-item-title
            :style="{ marginLeft: `${item.level * 20}px` }"
            v-if="item"
          >
            {{ item.nombre }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-combobox> -->

              </td>
              <td v-else>
                <v-select v-model="ins.xestado_academico" :items="treeData" disabled
                  :label="'Estado:' + (ins?.xestado_academico?.nombre_padre?.split('/')[0] || '')" dense hide-details
                  persistent-hint small-chips return-object @change="guardarEstadoAcademico(ins)">
                  <template v-slot:selection="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" class="ma-0" dense
                          :color="item?.nombre_padre.split('/')[0].trim() === 'Vigente' ? 'green' : 'red'"
                          style="width: 100%" label outlined block>
                          {{ item?.nombre }}
                        </v-chip>
                      </template>
                      <span>{{ item?.nombre_padre }}</span>
                    </v-tooltip>


                  </template>

                  <template v-slot:item="{ item }">
                    <span
                      :style="{ marginLeft: `${item?.level * 20}px !important`, cursor: item.disabled ? 'not-allowed !important' : 'pointer !important' }">
                      <!-- :style="{  marginLeft: `${item?.level * 20}px !important`}" <v-chip class="mx-0 my-1" :color="item.disabled?'red':'green'" :style="{ cursor: item.disabled?'not-allowed !important': 'pointer !important' }"  label outlined block>
                      {{ item.nombre }}
                    </v-chip> -->
                      {{ item.nombre }}
                    </span>
                  </template>
                </v-select>
              </td>

              <td v-if="isdna">
                <v-select v-model="ins.xestado_titulacion" :items="estados_titulacion" label="Estado seleccionado:"
                  dense hide-details persistent-hint small-chips return-object @change="guardarEstadoTitulacion(ins)">
                  <template v-slot:selection="{ item }">
                    <v-tooltip v-if="item.text == 'NO COMPLETO SU INSTRUMENTO DE TITULACION'" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" class="ma-0" :color="item.color" style="width: 100%" label
                          dense outlined>
                          {{ item.text }}
                        </v-chip>
                      </template>
                      <span> NOTA NO PRESENTÓ MONOGRAFIA O TESIS - NO DEFINIDO </span>
                    </v-tooltip>
                    <v-chip v-else class="ma-0" dense :color="item.color" style="width: 100%" label outlined block>
                      {{ item.text }}
                    </v-chip>
                  </template>

                  <template v-slot:item="{ item }">
                    <v-tooltip v-if="item.text == 'NO COMPLETO SU INSTRUMENTO DE TITULACION'" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" class="mx-0 my-1" :color="item.color" style="width: 100%" label
                          outlined>
                          {{ item.text }}
                        </v-chip>
                      </template>
                      <span> NOTA NO PRESENTÓ MONOGRAFIA O TESIS - NO DEFINIDO </span>
                    </v-tooltip>
                    <v-chip v-else class="mx-0 my-1" :color="item.color" style="width: 100%" label outlined block>
                      {{ item.text }}
                    </v-chip>
                  </template>
                </v-select>
              </td>
              <td v-else :style="`color:` + ins.xestado_titulacion ? ins.xestado_titulacion : ''">
                {{ ins.xestado_titulacion ? ins.xestado_titulacion.text : '' }}
              </td>

              <td v-if="isdna">
                <v-select v-model="ins.xestado_is_modular" :items="estados_is_modular" label="Estado seleccionado:"
                  dense hide-details persistent-hint small-chips return-object @change="guardarEstadoIsModular(ins)">
                  <template v-slot:selection="{ item }">
                    <v-chip class="ma-0" :color="item.color" label outlined block>
                      {{ item.text }}
                    </v-chip>
                  </template>

                  <template v-slot:item="{ item }">
                    <v-chip class="my-2" :color="item.color" label outlined block>
                      {{ item.text }}
                    </v-chip>
                  </template>
                </v-select>
              </td>
              <td v-else>
                <v-chip v-if="ins.xestado_is_modular" class="ma-0" :color="ins.xestado_is_modular.color" label outlined
                  block>
                  {{ ins.xestado_is_modular.text }}
                </v-chip>
              </td>

              <td>
                <v-chip small :color="getEstadoCarteraColor(ins.estado_cartera)" dark>
                  {{ ins.estado_ins === 0 ? 'Sin estado de cartera' : ins.estado_cartera }}
                </v-chip>
              </td>
              <td :style="`color:` + ins.xestado_ins_universidad ? ins.xestado_ins_universidad : ''">
                {{ ins.xestado_ins_universidad ? ins.xestado_ins_universidad.text : '' }}
              </td>
              <td>{{ ins.codigo_inscripcion || ins.codigoInscripcion || ins['codigo-inscripcion'] || '' }}</td>

              <td>
                <v-tooltip top vv-if="false" v-if="
                  $store.state.DATA_USER.idx == ins.asesor.id ||
                  $store.state.CARGO.id == 1 ||
                  permisosResponsablesTitulaciones ||
                  permisosDNA
                ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on"
                      @click="subir_documentacion(ins, programita, propositosTiposDocumentosPersona.RECEPCION)"
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-file-edit</v-icon>
                    </button>
                  </template>
                  Respaldo de Recepción de Documentos
                </v-tooltip>
              </td>

              <td class="text-right" style="min-width: 340px" v-if="is_user_of_sede">
                <v-progress-linear v-if="ins.loadinddeta" height="2" indeterminate color="indigo"></v-progress-linear>
                <v-tooltip top v-if="is_user_of_sede">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="viewDetailStudent(ins)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-eye</v-icon>
                    </button>
                  </template>
                  Ver Detalle de {{ ins.estudiante.nombres }} {{ parseApellidos(ins.estudiante, 1) }}
                  {{ parseApellidos(ins.estudiante, 2) }}
                </v-tooltip>

                <v-tooltip bottom v-if="
                  is_user_of_sede &&
                  ins.estado_ins == 1 &&
                  ($store.state.CARGO.id == 14 || $store.state.CARGO.id == 19 || $store.state.CARGO.id == 1)
                ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="editarplanpagos(ins)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-clipboard-edit-outline</v-icon>
                    </button>
                  </template>
                  Editar plan de pagos
                </v-tooltip>
                <!-- Agregar concepto pagos -->
                <v-tooltip bottom v-if="
                  is_user_of_sede && programita.sede.id == 17 &&
                  ins.estado_ins == 1 &&
                  ($store.state.CARGO.id == 14 || $store.state.CARGO.id == 19 || $store.state.CARGO.id == 1 || $store.state.CARGO.id == 15)
                ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="agregarConcepto(ins)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="orange">mdi-clipboard-edit-outline</v-icon>
                    </button>
                  </template>
                  Agregar Concepto
                </v-tooltip>

                <v-tooltip bottom v-if="
                  ins.estado_ins == 1 &&
                  programa.fase < 3 &&
                  ($store.state.CARGO.id == 14 || $store.state.CARGO.id == 19 || $store.state.CARGO.id == 1)
                ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="changeProgramaView(ins)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-undo-variant</v-icon>
                    </button>
                  </template>
                  Cambiar de programa
                </v-tooltip>

                <button v-if="ins.estado_ins == 0 && (is_user_of_sede || permit_migrar_upi)"
                  :disabled="$store.state.isonlyread" class="btn btn-sm btn-default" title="Cambiar a inscrito"
                  @click="cambiarinscrito(ins)">
                  <span class="glyphicon glyphicon-retweet"></span>
                </button>

                <v-tooltip bottom
                  v-if="$store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 25 || $store.state.CARGO.id == 1">
                  <template v-slot:activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" data-toggle="modal" data-target="#modal-ndescuento"
                      @click="solicitardescuento(ins)" v-if="ins.estado_ins == 1" v-show="($store.state.CARGO.id == 1 ||
                        $store.state.CARGO.id == 14 ||
                        $store.state.CARGO.id == 15 ||
                        $store.state.CARGO.id == 25 ||
                        $store.state.DATA_USER.id == ins.asesor.id) &&
                        sede_permitida
                        " class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-check-decagram</v-icon>
                    </button>
                  </template>
                  Solicitar descuento para {{ ins.estudiante.nombres }} {{ parseApellidos(ins.estudiante, 1) }}
                </v-tooltip>
                <v-tooltip bottom v-if="
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 1
                ">
                  <template v-slot:activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" data-toggle="modal" data-target="#modal-nliquidacioncar"
                      @click="solicitarliquidacion(ins)" v-if="ins.estado_ins == 1" v-show="($store.state.CARGO.id == 1 ||
                        $store.state.CARGO.id == 14 ||
                        $store.state.CARGO.id == 15 ||
                        $store.state.CARGO.id == 25 ||
                        $store.state.DATA_USER.id == ins.asesor.id) &&
                        sede_permitida
                        " class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-cash-lock</v-icon>
                    </button>
                  </template>
                  Liquidacion para {{ ins.estudiante.nombres }} {{ parseApellidos(ins.estudiante, 1) }}
                </v-tooltip>

                <v-tooltip bottom v-if="
                  $store.state.CARGO.id == 14 ||
                  $store.state.DATA_USER.id == ins.asesor.id ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 1
                ">
                  <template v-slot:activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="vermovimientos(ins)" v-show="sede_permitida"
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-cash-marker</v-icon>
                    </button>
                  </template>
                  Ver Movimientos {{ ins.estudiante.nombres }} {{ parseApellidos(ins.estudiante, 1) }}
                </v-tooltip>
                <v-tooltip bottom v-if="
                  (isgoup || categoria_id == 1 || categoria_id == 2 || categoria_id == 3 || categoria_id == -26 || categoria_id == 29 || categoria_id == 30 || categoria_id == 31 || categoria_id == 32 || categoria_id == 24 || categoria_id == 6 || categoria_id == 7 || categoria_id == 8 || categoria_id == 9) &&
                  ($store.state.CARGO.id == 14 ||
                    $store.state.CARGO.id == 15 ||
                    $store.state.CARGO.id == 25 ||
                    $store.state.CARGO.id == 19 ||
                    $store.state.CARGO.id == 1)
                ">
                  <template v-slot:activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" :disabled="loading_goup" @click="generarContrato(ins)"
                      v-if="ins.estado_ins == 1" v-show="($store.state.CARGO.id == 1 ||
                        $store.state.CARGO.id == 14 ||
                        $store.state.CARGO.id == 15 ||
                        $store.state.CARGO.id == 25 ||
                        $store.state.DATA_USER.id == ins.asesor.id) &&
                        sede_permitida
                        " class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-badge-account-alert</v-icon>
                    </button>
                  </template>
                  <span> Generar Contrato. </span>
                </v-tooltip>

                <v-tooltip top
                  v-if="$store.state.NETSUITE_VISIBLE && ($store.state.CARGO.id == 1 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 6)">
                  <template v-slot:activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="mandarANetSuite(ins)" class="btn btn-sm btn-default">
                      <v-icon color="orange" class="mx-1" small>mdi-refresh</v-icon>
                    </button>
                  </template>
                  <span>NetSuite</span>
                </v-tooltip>

                <!-- <v-tooltip
                  top
                  v-if="!$store.state.isonlyread && is_user_of_sede"
                  v-show="
                    $store.state.CARGO.id == 1 ||
                    $store.state.CARGO.id == 14 ||
                    $store.state.CARGO.id == 15 ||
                    $store.state.CARGO.id == 25 ||
                    $store.state.CARGO.id == 8
                  ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="editar(ins.estudiante)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-account-edit</v-icon>
                    </button>
                  </template>
                  Editar informacion de {{ ins.estudiante.nombres }} {{ parseApellidos(ins.estudiante, 1) }}
                </v-tooltip> -->

                <v-tooltip top v-if="!$store.state.isonlyread && is_user_of_sede" v-show="$store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 8
                  ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="editarfromTI(ins.estudiante)"
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-account-edit</v-icon>
                    </button>
                  </template>
                  Editar informacion de {{ ins.estudiante.nombres }} {{ parseApellidos(ins.estudiante, 1) }}
                </v-tooltip>

                <v-tooltip top v-show="sede_permitida">
                  <template #activator="{ on, attrs }">
                    <button v-if="!$store.state.isonlyread" :disabled="$store.state.CARGO.id == 13" v-bind="attrs"
                      v-on="on" data-toggle="modal" data-target="#modalc" @click="enviarCorreo(ins)"
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-email-alert</v-icon>
                    </button>
                  </template>
                  Enviar correo personalizado
                </v-tooltip>

                <v-tooltip top v-show="sede_permitida">
                  <template #activator="{ on, attrs }">
                    <button v-if="!$store.state.isonlyread" v-bind="attrs" v-on="on" data-toggle="modal"
                      data-target="#modalnoti" @click="enviarnotificacionper(ins)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-bell-alert</v-icon>
                    </button>
                  </template>
                  Enviar notificacion personalizada
                </v-tooltip>
                <v-tooltip top v-if="
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 4 ||
                  $store.state.CARGO.id == 3 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 25 ||
                  $store.state.CARGO.id == 16 &&
                  sede_permitida">
                  <template #activator="{ on, attrs }">
                    <button v-if="!$store.state.isonlyread" v-bind="attrs" v-on="on"
                      @click="viewSolicitudCertificado(ins)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="orange">mdi-star</v-icon>
                    </button>
                  </template>
                  Solicitud Certificado Universidad
                </v-tooltip>

                <v-tooltip top v-if="
                  $store.state.DATA_USER.id == ins.asesor.id ||
                  $store.state.CARGO.id == 8 ||
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 14
                ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="preEliminarInscripcion(ins.id, programita)"
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-delete-alert</v-icon>
                    </button>
                  </template>
                  Eliminar Inscripcion
                </v-tooltip>

                <v-tooltip top vv-if="false" v-if="
                  $store.state.DATA_USER.idx == ins.asesor.id ||
                  $store.state.CARGO.id == 1 ||
                  permisosResponsablesAdmisiones ||
                  permisosDNA
                ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on"
                      @click="subir_documentacion(ins, programita, propositosTiposDocumentosPersona.INSCRIPCION)"
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-file</v-icon>
                    </button>
                  </template>
                  Documentacion
                </v-tooltip>

                <v-tooltip top vv-if="false" v-if="
                  $store.state.DATA_USER.idx == ins.asesor.id ||
                  $store.state.CARGO.id == 1 ||
                  permisosResponsablesTitulaciones ||
                  permisosDNA
                ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on"
                      @click="subir_documentacion(ins, programita, propositosTiposDocumentosPersona.TITULACION)"
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-file-check-outline</v-icon>
                    </button>
                  </template>
                  Documentacion Titulación
                </v-tooltip>

                <v-tooltip top vv-if="false" v-if="
                  $store.state.DATA_USER.idx == ins.asesor.id ||
                  $store.state.CARGO.id == 1 ||
                  permisosResponsablesAdmisiones ||
                  permisosResponsablesTitulaciones ||
                  permisosDNA
                ">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on"
                      @click="subir_documentacion(ins, programita, propositosTiposDocumentosPersona.EMITIDO)"
                      class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-file-star-outline</v-icon>
                    </button>
                  </template>
                  Título de Postgrado
                </v-tooltip>

                <!-- <v-btn v-if="is_upi" color="orange darken-1" dark rounded @click="open_duplicar_in_q10" title="duplicar estudiante en el Q10">
                  Q10 <v-icon> mdi-open</v-icon>
                </v-btn> -->
                <v-tooltip top v-if="is_upi">
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" @click="open_duplicar_in_q10(ins)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="orange">mdi-share</v-icon>
                    </button>
                  </template>
                  matricular/duplicar estudiante en el Q10
                </v-tooltip>

                <!-- <v-tooltip
                  top
                  v-if="$store.state.CARGO.id == 1"
                >
                  <template #activator="{ on, attrs }">
                    <button v-bind="attrs" v-on="on" small @click="openmodalestado(ins)" class="btn btn-sm btn-default">
                      <v-icon small class="mx-1" color="primary">mdi-lock</v-icon>
                    </button>
                  </template>
                  Cambiar estado de inscripcion
                </v-tooltip> -->
              </td>
              <template v-if="programa_rest">
                <td v-if="!contraercolumnas && programa_rest.plataforma_id && programa_rest.categoria_id">
                  <v-tooltip v-if="!permissions()" top>
                    <template v-slot:activator="{ on, attrs }">
                      <button v-bind="attrs" v-on="on" @click="registerEditUserMoodle(ins)"
                        class="btn btn-sm btn-default">
                        <v-icon color="primary" class="mx-1" small>mdi-alpha-m-box</v-icon>
                      </button>
                    </template>
                    <span>Registrar en Moodle</span>
                  </v-tooltip>

                  <v-tooltip v-if="!permissions()" top>
                    <template v-slot:activator="{ on, attrs }">
                      <button v-bind="attrs" v-on="on" @click="editUserMoodle(ins)" class="btn btn-sm btn-default">
                        <v-icon color="primary" class="mx-1" small>mdi-account-edit</v-icon>
                      </button>
                    </template>
                    <span>Actualizar en Moodle</span>
                  </v-tooltip>

                  <v-tooltip v-if="!permissions()" top>
                    <template v-slot:activator="{ on, attrs }">
                      <button v-bind="attrs" v-on="on" @click="resetCredentialsMoodle(ins)"
                        class="btn btn-sm btn-default">
                        <v-icon color="primary" class="mx-1" small>mdi-lock</v-icon>
                      </button>
                    </template>
                    <span>Resetear Contraseña</span>
                  </v-tooltip>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <p v-show="inscripciones.length > 8">
        <router-link to="programas" class="btn btn-sm btn-link">
          <small> <span class="glyphicon glyphicon-arrow-left"></span> Volver</small></router-link
        >
      </p> -->

      <Alertas ref="xalertar" />
      <notifications group="auth" position="bottom right" />
      <notifications group="auth2" position="bottom right" />
      <notifications group="auth3" position="bottom right" />

      <ACrearUSerMoodle id="modalmoodleuser" v-bind:obj="seleccionadomoodle" v-on:exito="modalExito" />
      <modal id="modalmoodle" v-bind:obj="seleccionadox" v-on:exito="modalExito" />
      <modalest id="modalest" v-bind:obj="seleccionadox" v-on:exito="modalExito" />
      <AWhatsappContable id="modalcitows" v-bind:obj="modalws" />
      <modalc id="modalc" v-bind:obj="correoto" v-on:exito="modalExitoCorreo" />
      <modalnoti id="modalnoti" v-bind:obj="xnotificacion" v-on:exito="modalExitoCorreo" />
      <modalnotiall id="modalnotiall" v-bind:obj="xnotificacionall" :xbody="xbody" v-on:exito="modalExitoCorreo" />
      <div>
        <ADescuento :ins="insseleccionado" ref="adescuento" />
      </div>
      <div>
        <ACompensacion :ins="insseleccionado" ref="acompensacion" />
      </div>
      <div>
        <ALiquidacion :ins="insseleccionado" ref="aliquidacion" v-on:onliquidado="onliquidado" />
      </div>
      <div>
        <AMovimientos ref="refmovimientos" />
      </div>
      <div>
        <ADescuentoAprobacion :ins="insseleccionado" />
      </div>
      <div>
        <AsignarCobrador ref="asignarcobradorins" />
      </div>
      <div>
        <AsignarCobradorProg ref="asignarcobradorprog" />
      </div>
      <div>
        <AsignarCobradorProgIns ref="asignarcobradorprogins" />
      </div>
      <div>
        <AInscripcionEstado ref="inscripcionestado" />
      </div>
      <div>
        <AInscripcionEstadoAdministrativo ref="inscripcionestadoadmin"
          @estado-cambiado="onEstadoCambiadoAdministrativo" />
      </div>
      <div>
        <AEstadoPersona ref="estadopersona" />
      </div>
      <Cambio id="modalcam" :model="precambio" v-on:exito="modalExito" />
      <Detalle id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
    </div>
    <details-ins ref="refDetailIns"></details-ins>
    <change-programa ref="refChangeProgramaIns" v-on:onchangeprograma="onchangeprograma" />
    <update-user-moodle v-bind:register="true" ref="refUserUpdateMoodle"></update-user-moodle>
    <reset-password-moodle ref="refResetPassword" :programa="programita"></reset-password-moodle>
    <change-asesor ref="refChangeAsesor" @updateIns="updateInscripcion" />
    <MandarNetSuite ref="refMandarNetsuite" />
    <Docu ref="refDocu" />
    <Docu2 ref="refDocu2" />


    <SolicitudCertificado ref="refSolicitudCertificado" />
    <modal_propuesta_duplicar ref="refmodal_propuesta_duplicar" />

    <SubirDocumentacion ref="refSubirDocumentacion" />
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';

import modal from '@/components/AEstadoMoodle.vue';
import modalest from '@/components/AEstadoEstudiante.vue';
import Detalle from '@/components/ADetalleInscrito';
import ADescuento from '@/components/ADescuento';
import ACompensacion from '@/components/ACompensacion';
import ALiquidacion from '@/components/ALiquidacioncartera';
import AMovimientos from '@/components/AMovimientos';
import ADescuentoAprobacion from '@/components/ADescuentoAprobacion';
import ACrearUSerMoodle from '@/components/ACrearUSerMoodle';
import { parseJsonError, error, exito } from '@/components/Utils.js';
import modalc from '@/components/ACorreo.vue';
import modalnoti from '@/components/ANotificacion.vue';
import modalnotiall from '@/components/ANotificacionAll.vue';
import Cambio from '@/views/CambioPrograma';
import Alertas from '@/components/AAlertas.vue';
import AEstadoPersona from '@/components/APersonaEstado';
//import { getheadersrest } from '@/components/Utils';
import UpdateUserMoodle from '@/components/vuetify/UpdateUserMoodle.vue';
import ResetPasswordMoodle from '@/components/vuetify/ResetPasswordMoodle.vue';
import AWhatsappContable from '@/components/AWhatsappContable.vue';
import AsignarCobrador from '@/components/AAsignarCobrador.vue';
import AsignarCobradorProg from '@/components/AAsignarCobradorProg.vue';
import AsignarCobradorProgIns from '@/components/AAsignarCobradorProgIns.vue';
import AInscripcionEstado from '@/components/AInscripcionEstado.vue';
import AInscripcionEstadoAdministrativo from '@/components/AInscripcionEstadoAdministrativo.vue';
import MandarNetSuite from '@/components/Programa-insNetsuite.vue';
import SolicitudCertificado from './SolicitudCertificado.vue';
import Docu from './documents/documentos.vue';
import Docu2 from './documentos/subir.vue';
import modal_propuesta_duplicar from './upi/modal_propuesta_duplicar.vue';

// import Certificadococha from '@/views/Certificadococha'
// import CertificadoSigloxx from '@/views/CertificadoSigloxx'

import { mapGetters, mapState } from 'vuex';
import gql from 'graphql-tag';

import DetailsIns from './Inscripcion/DetailsIns';
import xaxios from '@/xaxios';
import ChangeAsesor from './programas/ChangeAsesor.vue';
import ChangePrograma from './programas/ChangePrograma.vue';
import {
  getEstadosTitulacion,
  setEstadoTitulacion,
  setEstadoInscritoUniv,
  setEstadoIsModular,
} from '../views/reportestitulaciones/index.js';
import ContraGOup from './programa-contrato-goup.vue'
import ContraCCA_cursos from './programa-contrato-cca-cursos.vue'
import SubirDocumentacion from './documentacion/SubirDocumentacion.vue';
import { PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA } from './comisiones/utils/constantes';

export default {
  data() {
    return {
      modalSolicitud: false,
      menu_name: process.env.VUE_APP_NAME_MENU,
      api_rest: process.env.VUE_APP_API_REST,
      programa_rest: null,
      isgoup: false,
      iscca: false,
      permit_migrar_upi: false,

      // EXCEL
      uri: 'data:application/vnd.ms-excel;base64,',
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      // END EXCEL
      buscar: '',
      correoto: { xid: -1, xtitle: 'X', xbody: 'X', all: false, isDefault: false, xsql: null },
      xnotificacion: { xidpersona: null },
      xbody: {
        xbody:
          'Estimado/a $nombre, se le comunica que tiene un saldo de $saldo Bs pendiente de pago referente al periodo $periodo.',
      },
      xnotificacionall: { xid: null, deudas: [] },
      seleccionadox: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, sede: { correos: null } },
      seleccionadomoodle: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, estudiante: {}, update: false },
      seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
      //verPagos: false,
      modalws: { texto: '', tel: '', estudent: {} },
      verCuotas: false,
      contraercolumnas: true,
      msg: 'Cargando....',
      pro: '',
      modelcertificado: { inscripcion: { id: -1 } },
      precambio: { id: -1, idasesor: -1, ins: null },
      programita: { sede: {} },
      universidad: {},
      sede: {},
      idprograma: {},
      inscripciones: [],
      convenio: true,
      sede_certificado: false, // para verif que tiene acceso a la sede

      total_matricula: 0,
      total_matrisaldo: 0,
      total_colegiatura: 0,
      total_colegiasaldo: 0,
      total_certificacion: 0,
      total_certificasaldo: 0,
      sede_permitida: false,
      inscrito: null,

      paranotificar: [],
      idsinscritos: [],
      deudas: [],
      insseleccionado: {},
      asesores: [],
      filtro_size: 0,
      categoria_id: 0,
      is_user_of_sede: false,

      isvalidogencontrato: false,
      modelito: null,
      estados_academicos: [],
      treeData: [],
      groupedData: [],
      estados_titulacion: [],
      estados_ins_universidad: [],
      estados_is_modular: [],
      isdna: false,
      loading_goup: false,
      is_upi: false,
      propositosTiposDocumentosPersona: PROPOSITOS_TIPOS_DOCUMENTOS_PERSONA,
    };
  },
  computed: {
    ...mapState({ programa: (state) => state.programa.value }),
    ...mapGetters({
      permisosResponsablesAdmisiones: 'comision/permisosResponsablesAdmisiones',
      permisosDNA: 'comision/permisosDNA',
      permisosResponsablesTitulaciones: 'comision/permisosResponsablesTitulaciones',
    }),
  },
  components: {
    UpdateUserMoodle,
    ResetPasswordMoodle,
    ACrearUSerMoodle,
    Cambio,
    Alertas,
    Detalle,
    modalest,
    modal,
    modalc,
    modalnoti,
    modalnotiall,
    ADescuento,
    ACompensacion,
    ALiquidacion,
    AMovimientos,
    ADescuentoAprobacion,
    DetailsIns,
    ChangeAsesor,
    AWhatsappContable,
    AsignarCobrador,
    AsignarCobradorProg,
    AsignarCobradorProgIns,
    ChangePrograma,
    AInscripcionEstado,
    AInscripcionEstadoAdministrativo,
    AEstadoPersona,
    MandarNetSuite,
    Docu,
    Docu2,
    ContraGOup,
    ContraCCA_cursos,
    SolicitudCertificado,
    modal_propuesta_duplicar,
    SubirDocumentacion,
  },
  watch: {
    '$store.state.CARGO': function () {
      //window.console.log( "JEJEJEEJEJ ----\n",this.$store.state.CARGO )
      this.isuser();
    },
    buscar: function () {
      this.myFunction1(this.buscar);
    },
    contraercolumnas: function () {
      window.sessionStorage.setItem('xcontraercolumnas', this.contraercolumnas);
    },
  },
  methods: {
    getEstadoAdministrativoColor(estado) {
      // Manejar caso nulo o indefinido
      if (!estado) {
        return 'grey';
      }

      // Mapeo de estados a colores
      // const coloresEstado = {
      //   'Prospecto': 'blue',
      //   'Preinscrito': 'cyan',
      //   'Inscrito': 'green',
      //   'Inscrito Transferido': 'teal',
      //   'Retirado': 'orange',
      //   'Retirado Cambiado': 'red'
      // };
      const coloresEstado = {
        '1': 'blue',
        '2': 'cyan',
        '3': 'green',
        '4': 'teal',
        '5': 'red',
        '6': 'orange',
        '7': 'brown lighten-3'
      };


      return coloresEstado[estado] || 'grey';
    },
    getEstadoCarteraColor(estado) {
      const estadoLower = estado.toLowerCase();

      if (estadoLower.includes('riesgo incobrable')) return 'red darken-2';
      if (estadoLower.includes('mora')) return 'red';
      // if (estadoLower.includes('naranja')) return 'orange';
      if (estadoLower.includes('retrasado')) return 'yellow darken-2';
      if (estadoLower.includes('vigente')) return 'green';
      if (estadoLower.includes('liquidado')) return 'blue';
      if (estadoLower.includes('exento')) return 'teal';


      return 'grey';
    },
    permissions() {
      return this.$store.state.CARGO.id != 1 && this.$store.state.CARGO.id != 8 && this.$store.state.CARGO.id != 5;
    },
    getFase(fase) {
      if (fase == 0) return 'NO APROBADO';
      else if (fase == 1) return 'INSCRIPCIONES';
      else if (fase == 2) return 'EN DESARROLLO';
      else if (fase == 3) return 'CONCLUIDO';
      else if (fase == 4) return 'ELABORACION TRABAJOS FINALES';
      else if (fase == 5) return 'RECEPCION DE REQUISITOS DE TITULACION';
      else if (fase == 6) return 'ARMADO CARPETAS';
      else if (fase == 7) return 'PAGO ARANCELES';
      else if (fase == 8) return 'PROCESO TITULACION';
      else if (fase == 9) return 'CERTIFICADOS ENTREGADOS';
      else if (fase == 10) return 'NO EJECUTADO';
      else return 'DESCONOCIDO: ' + fase;
    },
    registerEditUserMoodle({ estudiante }) {
      this.$refs.refUserUpdateMoodle.showThisView(estudiante.id, true);
    },
    editUserMoodle({ estudiante }) {
      this.$refs.refUserUpdateMoodle.showThisView(estudiante.id, false);
    },
    resetCredentialsMoodle({ estudiante }) {
      this.$refs.refResetPassword.showThisView(estudiante.id);
    },
    mandarANetSuite({ estudiante }) {
      // window.console.log('**************',this);
      let idsedeprog = this.programita.sede.id;
      let sede = this.$store.state.CARGOS.find(c => c.idsede == idsedeprog);
      const customdata = {
        estudiante_id: estudiante.id,
        postragrado_id: this.programita.postgrado.id,
        sede: { ...sede.sede }
      }
      this.$refs.refMandarNetsuite.openInsNet(estudiante, customdata, true);
      // window.console.log('estudiante', estudiante);
    },
    openDialogChangeAsesor(inscrito) {
      /*const iduser = this.$store.state.DATA_USER.id;
      if (iduser == 43) {
        this.$root.$notify.show(`No tienes.. permitido realizar esta accion.`, {
          color: 'red',
          x: 'right',
        });
        return;
      }*/

      // SOLO MASTER PUEDE CAMBIAR DE ASESOR

      if (this.$store.state.CARGO.id == 1 /* || this.$store.state.CARGO.id == 8 */) {
        this.inscrito = inscrito;
        this.$refs.refChangeAsesor.showThisView(inscrito);
      }
    },
    updateInscripcion(asesor) {
      this.inscrito.asesor = asesor;
    },

    formatCode() {
      if (!this.programa) return '';
      return `${this.programa.postgrado.categoria.nombre.slice(0, 1)}-${this.programa.id}`.toUpperCase();
    },
    isSedePermitida(sede_actual) {
      var sed = this.$store.state.CARGOS.find((x) => x.idsede == sede_actual);
      this.sede_permitida = sed != null;
      // window.console.log("IS DESE PERMITIDA", sede_actual,sed,this.sede_permitida);
    },
    cambioPrograma(ins) {
      // window.console.log( ins )
      this.precambio.id = ins.id;
      this.precambio.idasesor = ins.asesor.id;
      this.precambio.ins = ins;
    },
    showInscripcion(p) {
      if (p.fase > 2) {
        this.$notify(
          exito(
            'AVISO:',
            'Este programa no esta en fase de inscripciones, contacte con parte academica si tiene algun inconveniente.',
          ),
        );
      } else {
        window.sessionStorage.setItem('xprograma', JSON.stringify(p));
        window.sessionStorage.setItem('route_ins', 'programains');
        this.$router.push({ name: 'inscripcionadd' });
      }
    },
    generarCertificados() {
      window.sessionStorage.setItem('xprograma', JSON.stringify(this.programa));
      if (this.programita.fase < 3)
        this.$root.$notify.show(
          'Este programa no tiene la fase necesaria para emitir certificados, contacte con parte academica.',
          { color: 'red' },
        );
      else {
        // if (process.env.VUE_APP_NAME === 'CIBERKIDS')
        //   this.$router.push({ name: 'certificate.ready' });
        // else
        this.$router.push({ name: 'certificadostodos' });
      }
    },
    onchangeprograma(idins) {
      //window.console.log('cambiado: ',idins);
      let existe = this.inscripciones.find((x) => x.id == idins);
      if (existe) existe.estado_ins = 3; // cambiado
    },
    irasignaciones() {
      window.sessionStorage.setItem('xprograma', JSON.stringify(this.programa));
      this.$router.push({ name: 'asignacionesv2' });
    },
    iracalificaciones() {
      window.sessionStorage.setItem('xprograma', JSON.stringify(this.programa));
      this.$router.push({ name: 'calificacionesv2' });
    },
    openmodalestado(ins) {
      this.$refs.estadopersona.openmodal(ins);
    },
    subir_documentacion(ins, prog, proposito) {
      // this.$refs.refDocu.openmodal(ins_id, prog)
      // this.$refs.refDocu2.openmodal(ins, prog)
      if (ins.estado_academico == null) {
        this.$notify(error('AVISO:', 'El inscrito no tiene estado academico, no se puede subir documentacion.'));
        
        return;
      }
      this.$refs.refSubirDocumentacion.abrir(ins, prog, proposito);
    },
    preEliminarInscripcion(/*idins, programa*/) {
      this.$root.$notify.show(`No tienes permitido realizar eliminacion.`, {
        color: 'red',
        x: 'right',
      });
      return;
      /* const iduser = this.$store.state.DATA_USER.id;
       if (iduser == 43) {
         this.$root.$notify.show(`No tienes permitido realizar esta accion.`, {
           color: 'red',
           x: 'right',
         });
         return;
       }
       this.$refs.xalertar.reset();
       this.idNewInscripcion = idins;
       var vue = this;
       var opt = {
         verification: 'eliminar',
         verificationHelp: 'Escriba "[+:verification]" para eliminar esta inscripcion.',
         animation: 'bounce',
         type: 'hard',
       };
       this.$dialog
         .confirm(
           'Confirmacion<br><br>Esta accion es irreversible, solo se puede eliminar una inscripcion cuando no haya cancelado ningun pago.<br>',
           opt,
         )
         .then(function () {
           vue.eliminarInscripcion(programa);
         })
         .catch((e) => {
           window.console.error(e);
         });*/
    },
    eliminarInscripcion(/* programa */) {
      // window.console.log('EliminarIns:', programa);
      var vue = this;
      /*this.$refs.xalertar.cargando("Eliminando inscripcion...");
            var sql = gql`mutation{ deleteInscripcion(input:{ id:${this.idNewInscripcion},idprograma: ${programa.id} }){ok,errors{message}} }`;
            this.idNewInscripcion = 0;

            this.$apollo
                .mutate({
                    mutation: sql,
                })
                .then((data) => {
                    window.console.log('ELIMINAR: ',data.data);
                    if (data.data.deleteInscripcion.ok) {
                        vue.$notify(exito("Eliminado", "El participante fue eliminado."));
                        vue.$refs.xalertar.success("Inscripcion eliminada.");
                        vue.idNewInscripcion = 0;
                        vue.validarDatos();
                    } else {
                        var errores = JSON.stringify(data.data.deleteInscripcion.errors);
                        var obj = JSON.parse(errores);
                        var vals = "";
                        obj.forEach(function(k) {
                            vals += Object.values(k) + "-\n\t";
                        });
                        vue.msg = "";
                        vue.activo = true;
                        vue.$refs.xalertar.invalido(vals);
                        vue.$notify(error("No Eliminado", vals));
                    }
                })
                .catch((error) => {
                    this.activo = true;
                    vue.$refs.xalertar.invalido("No se pudo eliminar la inscripcion, ya hizo pagos.");
                    vue.$notify(parseJsonError(error, "deleteInscripcion"));
                });*/
      const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${this.idNewInscripcion}`;
      // window.console.log(url);
      xaxios
        .delete(url)
        .then((res) => {
          // window.console.log(res);
          vue.inscripciones = vue.inscripciones.filter((x) => x.id != vue.idNewInscripcion);
          let noti = { group: 'auth', title: '', text: res.data.data, duration: 5000 };
          vue.$notify(noti);
        })
        .catch((error) => {
          window.console.error(error);
          this.activo = true;
          vue.$refs.xalertar.invalido(error.response.data.data);
          let noti = {
            group: 'auth',
            title: 'Se ha producido un error',
            text: error.response.data.data,
            duration: 10000,
            type: 'error',
          };
          vue.$notify(noti);
        });
    },

    tableToExcel(table, name) {
      if (!table.nodeType) table = this.$refs.table;
      var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
      var link = document.createElement('a');
      if (this.pro) {
        link.download = this.pro + '.xls';
      } else {
        link.download = 'reporte_programa.xls';
      }
      link.href = this.uri + this.base64(this.format(this.template, ctx));
      link.click();
    },
    modalExito() { },
    parseDoc(u) {
      if (u == null) return '';
      if (u.departamento != null) return u.num_doc + ' ' + u.departamento.extension;
      return u.num_doc;
    },
    parseCorreo(u) {
      if (u == null) return '';
      return u.email;
    },
    parseTelefono(u) {
      if (u == null) return '';
      return u.telefono1;
    },
    parseLogin(u) {
      if (u == null) return '';
      return u.usuario_moodle;
    },
    parseClave(u) {
      if (u == null) return '';
      return u.clave_moodle;
    },
    parsePrograma(p) {
      if (p == null) return '';
      var post = '';
      if (p.postgrado != null) post = p.postgrado.nombre;
      return post + ' version:' + p.version + ', grupo:' + p.grupo + ', gestion:' + p.gestion;
    },
    parseProgram(p) {
      if (p == null) return '';
      var cate = '';
      var post = '';
      if (p.postgrado.categoria != null) cate = p.postgrado.categoria.nombre;
      if (p.postgrado != null) post = p.postgrado.nombre;
      return cate + ' - ' + post;
    },
    parseEstudiante(e) {
      if (e == null) return '';
      var seg = e.seg_apellido;
      if (seg == null) seg = '';
      return e.pri_apellido + ' ' + seg + ' ' + e.nombres;
    },
    parseApellidos(e, unodos) {
      //window.console.log("APELLIDOS", e);
      if (e == null) return '';
      var seg = e.seg_apellido;
      if (seg == null) seg = '';
      if (unodos == 1) return e.pri_apellido;
      else return seg;
      //return e.pri_apellido+" "+seg;
    },
    parseSede(p) {
      if (p == null) return '';
      if (p.sede == null) return '-';
      return p.sede.nombre;
    },
    parseFecha(f) {
      var date = new Date(f);
      var a = date.getFullYear();
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m < 10) m = '0' + m;
      if (d < 10) d = '0' + d;
      return d + '-' + m + '-' + a;
    },
    parseciudad(c) {
      if (!c) return '';
      return c.nombre;
    },
    parseIns(ins, certificado_id) {
      var str = '';
      if (ins == 0) str = 'Pre inscrito';
      else if (ins == 1) str = 'Inscrito';
      else if (ins == 2) str = 'retirado';
      else if (ins == 3) str = 'cambiado';
      else if (ins == 4) str = 'congelado';
      else if (ins == 5) str = 'pagado';
      if (certificado_id) str += '* ' + ins;
      return str;
    },
    parseInsAdministrativo(ins) {
      const estados = {
        1: 'Prospecto',
        2: 'Preinscrito',
        3: 'Inscrito',
        4: 'Inscrito Transferido',
        5: 'Retirado',
        6: 'Retirado Cambiado',
        7: 'Observado',
      };

      let str = estados[ins] || 'Sin estado';



      return str;
    },
    parseInsColor(ins) {
      if (ins == 0) return 'background:#EFFFA8';
      else if (ins == 1) return 'background:#A8FFA8';
      else if (ins == 2) return 'background:#FFA8B1';
      else if (ins == 3) return 'background:#FFE0A8';
      else if (ins == 4) return 'background:#A8D3FF';
      else if (ins == 5) return 'background:#FFA8F2';
      else return '';
    },
    validarDatos() {
      if (this.idprograma == null) return;
      this.buscarInscripciones();
    },
    cambioEstadoEstudiante(ins) {
      var estudiante = ins.estudiante;
      this.seleccionadox.xid = ins.id;
      this.seleccionadox.estudiante = estudiante;
      this.seleccionadox.programa = this.programita;
      this.seleccionadox.inscripcion = ins;
      this.seleccionadox.sede = this.sede;
      //window.console.log( "PAL MOODLE: ",window.stringifyObject(ins) )
    },
    registrarMoodle(ins, update) {
      var estudiante = ins.estudiante;
      this.seleccionadomoodle.xid = ins.id;
      this.seleccionadomoodle.estudiante = estudiante;
      this.seleccionadomoodle.sede = this.sede;
      this.seleccionadomoodle.update = update;
      // window.console.log( "PAL MOODLE: ",window.stringifyObject(ins) )
    },
    cambiarEstado(ins) {
      var estudiante = ins.estudiante;
      var nestado = !ins.estudiante.estado;
      this.seleccionadox.xtitle = 'Cambiar Estado';
      this.seleccionadox.xbody = `<b>Estudiante:</b> ${estudiante.nombres} ${estudiante.pri_apellido}.<br> <b>Moodle:</b> ${estudiante.usuario_moodle}.<br><b>Nuevo Estado:</b> ${nestado}`;
      this.seleccionadox.xusername = ins.estudiante.usuario_moodle;
      this.seleccionadox.xid = ins.id;
      this.seleccionadox.xestado = nestado;
      this.seleccionadox.sede = this.sede;
      // window.console.log( "VVVVVVVVVVVVVVVVVVVVVVVV",window.stringifyObject(this.seleccionadox),window.stringifyObject(ins) );
    },
    editar(est) {
      this.$notify(error('En Desarrollo', '....'));
      window.sessionStorage.setItem('xestudiante', JSON.stringify(est));
      window.sessionStorage.setItem('xxatrs', 'programains');
      this.$router.push({ name: 'estudiantesmod' });
    },
    editarfromTI(est) {
      this.$router.push('editperson?id=' + est.id);
    },
    verDetalles(id) {
      // window.console.log( "ID DETALLE: ",id );
      var msg = 'Detalle de la inscripcion';
      var body = 'Detalles';
      var tag = gql`
        query{
          getInscripcion(id:${id}){ 
            estudiante{num_doc,nombres,pri_apellido,seg_apellido,domicilio,telefono1,telefono2,email,departamento{nombre,extension}}
            id,estado_ins,observaciones,fecha_registro,matricula{monto,saldo},
            monto_colegiatura,monto_certificacion, 
            cuotas,lista_cuotas{monto,saldo,fecha},certificacion{monto,saldo}
          }
        }
        `;
      this.seleccionado = { xid: 12, xtitle: msg, xbody: body, xsql: tag };
    },

    enviarCorreoDefault(ins) {
      if (!ins.estudiante.seg_apellido) ins.estudiante.seg_apellido = '';
      var est = ins.estudiante.nombres + ' ' + ins.estudiante.pri_apellido + ' ' + ins.estudiante.seg_apellido;
      var link = `Enlace: ${process.env.VUE_APP_DOMAIN_MOODLE} \n`;
      var datos = link + 'Usuario: ' + ins.estudiante.usuario_moodle + ' \nClave:' + ins.estudiante.clave_moodle + '';
      var person =
        '\n\nConfirme sus datos personales para su certificado:\nNombres: ' +
        est +
        '\nEmail: ' +
        ins.estudiante.email +
        '\nCelular: ' +
        ins.estudiante.telefono1;
      this.correoto.xid = -1;
      this.correoto.xtitle = 'Enviar Datos de Acceso del Estudiante';
      this.correoto.xbody =
        '<p>Hola ' + est + ', te enviamos tus datos de acceso a la plataforma Moodle:</p>\n\n' + datos + ' ' + person;
      this.correoto.all = false;
      this.correoto.isDefault = true;
      this.correoto.xsql = null;
      this.correoto.xcorreo = ins.estudiante.email;
      //this.correoto.xcorreo = 'eclipseconsol@gmail.com';
      this.correoto.xasunto = `${process.env.VUE_APP_DOMAIN_MOODLE} Datos de acceso`;
      this.correoto.xnombre = 'Datos';
      // window.console.log( ins );
    },
    enviarCorreo(ins) {
      this.correoto.xid = -1;
      this.correoto.xtitle = 'Enviar Correo Personalizado al Estudiante';
      this.correoto.xbody = '';
      this.correoto.all = false;
      this.correoto.isDefault = false;
      this.correoto.xsql = null;
      this.correoto.xcorreo = ins.estudiante.email;
      //this.correoto.xcorreo = 'eclipseconsol@gmail.com';
      this.correoto.xasunto = '';
      this.correoto.xnombre = '';
      // window.console.log( ins );
    },
    enviarnotificacionper(ins) {
      this.xnotificacion.xidpersona = ins.estudiante.id;
      // window.console.log( 'INSCRIPCION:',ins );
    },
    enviarnotificacionall() {
      this.xnotificacionall.xid = new Date().getTime();
      this.xnotificacionall.deudas = this.deudas;
    },
    onliquidado(upd) {
      // window.console.log(upd);
      let ins = this.inscripciones.find((x) => x.id == upd.inscripcion_id);
      if (ins) {
        ins.estado_ins = 2;
      }
    },
    modalExitoCorreo() { },

    whatsapp(tel, pro, est) {
      // window.console.log('>>>');
      let iduser = this.$store.state.DATA_USER.id;
      let isdepcomunicacion = iduser == 44;
      if (isdepcomunicacion) {
        this.whatsappcomunicacionsuc(tel, pro, est);
        return;
      }

      let cargo = this.$store.state.CARGO;
      let iscontable = cargo.id == 14 || cargo.id == 15 || cargo.id == 25;
      var p = this.parseProgram(pro);
      var usu = this.parseLogin(est);
      var cla = this.parseClave(est);
      var us = this.$store.state.DATA_USER;
      if (us.seg_apellido == null) us.seg_apellido = '';
      var user = us.nombres + ' ' + us.pri_apellido + ' ' + us.seg_apellido;

      // if (!tel.startsWith('591')) tel = '591' + tel;
      var txt = '';
      var txt2 = '';
      if (iscontable) {
        //txt = `Yo soy la Lic. ${user} yo seré la persona que le va a colaborar en todo el proceso desde el area economica financiera `;
        //this.modalws.texto = txt;
        this.modalws.tel = tel;
        this.modalws.estudent = est;
        window.$('#modalcitows').modal('show');
        //window.console.log( txt );
      } else {
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let nombre = 'La ' + process.env.VUE_APP_NAME;
        let moodle = process.env.VUE_APP_DOMAIN_MOODLE;
        let appname = process.env.VUE_APP_NAME;
        if (unidad == 10) {
          nombre = 'El DBS';
          // moodle = 'https://virtual2.posgradouap.edu.bo/login/index.php';
          moodle = 'https://campus.dbussinesschool.com/login/index.php';
          appname = 'Digital Business School';
        }
        if (unidad == 6) {
          nombre = 'Cybercorp';
          moodle = 'https://academy.cybercorp.com.bo/moodle/login/index.php';
          appname = 'Cybercorp';
        }
        if (unidad == 14) {
          nombre = 'ISPI';
          moodle = 'https://campus.ispi.edu.pa/login/index.php';
          appname = 'ISPI';
        }
        if (unidad == 15) {
          nombre = 'ISPI';
          moodle = 'https://campus.upi.edu.pa/login/index.php';
          appname = 'ISPI';
        }

        //window.console.log('unidad: ',unidad)
        txt =
          `*${nombre}* le saluda y le felicita por tener a la institución como la primera opción para continuar con su desarrollo profesional, por este medio le envió sus datos de acceso a la Plataforma Virtual, para acceder a los contenidos, trabajos prácticos y calificaciones de los módulos del *` +
          p +
          '*. \n\nAnte cualquier duda o consulta, no dude en contactarme por este medio, a fin de guiarle u orientarle. \n\nAtte.: *' +
          user +
          `*, Dpto. de Sistemas ${appname}\n`;
        txt2 = `*Datos de Acceso:* \n\n ${moodle} \n\n*Usuario:* ` + usu + ' \n*Contraseña:* ' + cla;

        txt = encodeURIComponent(txt + '\n\n' + txt2);
        //window.open(`${process.env.VUE_APP_API_WHATSAPP}` + tel + '&text=' + txt);
        window.open(`https://wa.me/${tel}?text=${txt}`);
      }
    },
    whatsappcomunicacionsuc(tel, pro) {
      var us = this.$store.state.DATA_USER;
      if (us.seg_apellido == null) us.seg_apellido = '';
      //if (!tel.startsWith('591')) tel = '591' + tel;
      let date = new Date(pro.fecha_inicio + ' 00:00');
      let dstr = date.getDay();
      let dia = date.getDate();
      let mes = date.getMonth() + 1;
      if (dstr == 0) dstr = 'domingo';
      else if (dstr == 1) dstr = 'lunes';
      else if (dstr == 2) dstr = 'masrtes';
      else if (dstr == 3) dstr = 'miercoles';
      else if (dstr == 4) dstr = 'jueves';
      else if (dstr == 5) dstr = 'viernes';
      else if (dstr == 6) dstr = 'sabado';

      if (mes == 1) mes = 'enero';
      else if (mes == 2) mes = 'febrero';
      else if (mes == 3) mes = 'marzo';
      else if (mes == 4) mes = 'abril';
      else if (mes == 5) mes = 'mayo';
      else if (mes == 6) mes = 'junio';
      else if (mes == 7) mes = 'julio';
      else if (mes == 8) mes = 'agosto';
      else if (mes == 9) mes = 'septiembre';
      else if (mes == 10) mes = 'octubre';
      else if (mes == 11) mes = 'noviembre';
      else if (mes == 12) mes = 'diciembre';
      let fecha = `${dstr} ${dia} de ${mes}`;
      const programa = pro.nombre_compuesto.replace(/(\(.+\))/g, '').trim();
      var texto = `Estimado Diplomante a través de la presente queremos darle la bienvenida a esta gran familia que es ${process.env.VUE_APP_NAME}, formando parte ahora de ${programa}, que dará inicio el día ${fecha}.\n\nReciba un saludo cordial.\n_____\nLic. Paola Andrea Ortiz Tejerina\nDpto. Comunicación ESAM TARIJA SUCURSAL`;

      texto = texto.replace(/ /g, ' ');
      //window.console.log('texto', texto);
      texto = encodeURIComponent(texto);
      window.open(`${process.env.VUE_APP_API_WHATSAPP}` + tel + '&text=' + texto);
    },
    whatsappconta(tel, est) {
      let cargo = this.$store.state.CARGO;
      let iscontable = cargo.id == 14 || cargo.id == 15 || cargo.id == 25 || cargo.id == 1;
      var us = this.$store.state.DATA_USER;
      if (us.seg_apellido == null) us.seg_apellido = '';
      //if (!tel.startsWith('591')) tel = '591' + tel;
      if (iscontable) {
        this.modalws.tel = tel;
        this.modalws.estudent = est;
        window.$('#modalcitows').modal('show');
      }
    },
    pagos(id, estudiante) {
      window.sessionStorage.setItem('xins', JSON.stringify(id));
      window.sessionStorage.setItem('pago_estudiante', JSON.stringify(estudiante));
      window.sessionStorage.setItem('routerTo', 'programains');
      this.$router.push({ name: 'pagos' });
    },
    cambiarinscrito(ins) {
      //window.console.log(ins);
      const iduser = this.$store.state.DATA_USER.id;
      const rolid = this.$store.state.CARGO.id;
      if (!ins.asesor) ins.asesor = {};
      if ((iduser != ins.asesor.id && rolid != 1) && !this.permit_migrar_upi) {
        this.$root.$notify.show(`Este participante no es tu inscripcion`, {
          color: 'red',
          x: 'right',
        });
        return;
      }
      const idsede = this.$store.state.CARGO.sede.id
      const contiene_avd = this.programa.nombre_compuesto.includes('U301 AVANZADO)')
      window.console.log('contiene_avd', contiene_avd);

      if (idsede == 82 && contiene_avd) {
        const u = `/generar_plan_upi/${this.programa.id}?ins_id=${ins.id}&asesor_id=${ins.asesor.id}&doc=${ins.estudiante.num_doc}`
        this.$router.push(u);
        return;
      }

      this.$store.dispatch('inscripcion/selectInscripcion', ins);
      //window.console.log( 'jejej',ins );
      this.programita.inscripcion_id = ins.id;
      this.programita.estudiante_id = ins.estudiante.id;
      window.sessionStorage.setItem('xprograma', JSON.stringify(this.programita));
      window.sessionStorage.setItem('xpreinscrito', JSON.stringify(ins));
      this.$router.push({ name: 'inscripcionrest' });
    },
    generarContrato(ins) {
      //window.alert('Por el momento no esta disponible la generacion de contratos' + ins.id);
      if (!this.isvalidogencontrato) {
        this.$notify(
          exito(
            'ALERTA:',
            'Los contratos solo estan disponible para los programas que tienen fecha de inicio desde noviembre de 2021.',
          ),
        );
        return;
      }

      this.programita.estudiante_id = ins.estudiante.id;
      window.sessionStorage.setItem('xinscrito', JSON.stringify(ins));
      window.sessionStorage.setItem('xprograma', JSON.stringify(this.programita));
      if (this.isgoup) this.generarContratoGoup(ins)
      else if (this.iscca) this.generarcontratoCca(ins)
      else {
        const categoria = this.programita.postgrado.categoria.id;
        if (categoria == 1 || categoria == 2 || categoria == 3) {
          this.$router.push({ name: 'programa-contrato-pdf' });
        } else {
          this.$router.push({ name: 'programa-contrato' });
        }
      }
    },
    generarContratoGoup(ins) {
      // window.alert('Contrato para GO Up, aun estamos trabajando arduamente para esto.')
      this.$refs.refContraGOup.setData(ins, this);
      // window.console.log('ins',ins);
    },
    generarcontratoCca(ins) {
      if (
        this.programa.id != 7926 &&
        this.programa.id != 7919 &&
        this.programa.id != 7921 &&
        this.programa.id != 7917 &&
        this.programa.id != 7923 &&
        this.programa.id != 7916 &&
        this.programa.id != 7918 &&
        this.programa.id != 2685 &&
        this.programa.id != 7922
      ) {
        this.$root.$notify.show('El contrato no esta disponible pa este programita :)', { color: 'orange', x: 'right' });
        return;
      }
      this.$refs.refContraCCA_cursos.setData(ins, this.programita, this);
    },
    solicitardescuento(ins) {
      this.$refs.adescuento.getdescuentostipo(ins, this.programa);
      this.insseleccionado = ins;
    },
    solicitarcompensacion(ins) {
      this.$refs.acompensacion.getdescuentostipo(ins, this.programa);
      this.insseleccionado = ins;
    },
    solicitarliquidacion(ins) {
      this.$refs.aliquidacion.getdescuentostipo(ins, this.programa);
      this.insseleccionado = ins;
    },
    vermovimientos(ins) {
      this.$refs.refmovimientos.open(ins);
    },
    aprobardescuento(ins) {
      this.insseleccionado = ins;
    },
    buscarInscripciones() {
      this.$refs.xalertar.cargando();
      var vue = this;
      //var sql = gql`query{ getPrograma(id:${this.idprograma}){arte,universidad{nombre,convenio,id},sede{id,nombre,correos{tipo,direccion}},inscripciones{observaciones,certificado_id,id,estado_ins,fecha_registro,asesor{id},estudiante{id,email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,sexo,departamento{extension},profesiones{id,nombre},pais{nombre},estado,institucion{id,nombre,abreviatura},domicilio,fecha_nac,est_civil},asesor{num_doc,num_doc,nombres,pri_apellido,seg_apellido},programa{id,nombre_compuesto,version,grupo,fecha_inicio,fecha_fin,sede{id,nombre,ciudad{nombre}},postgrado{nombre,creditaje,carga_horaria,categoria{nombre}}}}}}`;
      //var sql = gql`query{ getPrograma(id:${this.idprograma}){arte,sede{id,nombre},inscripciones{observaciones,id,estado_ins,fecha_registro,asesor{id},estudiante{id,email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,sexo,departamento{extension},profesiones{id,nombre},pais{nombre},estado,institucion{id,nombre,abreviatura},domicilio,fecha_nac,est_civil},asesor{num_doc,num_doc,nombres,pri_apellido,seg_apellido},programa{id,nombre_compuesto,version,grupo,fecha_inicio,fecha_fin,sede{id,nombre,ciudad{nombre}},postgrado{nombre,creditaje,carga_horaria,categoria{nombre}}}}}}`;
      // var sql = gql`query{ getPrograma(id:${this.idprograma}){inscripciones{id,estado_ins,idestadotitulacion,inscrito_universidad,fecha_registro,estudiante{id,email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,sexo,departamento{extension},ciudad{nombre},profesiones{id nombre},institucion{nombre,abreviatura},pais{id nombre},estado,domicilio,fecha_nac,est_civil},asesor{id,telefono1,num_doc,nombres,pri_apellido,seg_apellido} }}}`;
      var sql = gql`query{ getPrograma(id:${this.idprograma}){inscripciones{id,estado_ins,idestadotitulacion,inscrito_universidad,estado_administrativo_id,is_modular,estado_cartera, cuotas_vencidas,cuotas_pendientes,deuda_total,fecha_registro,estudiante{id,email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,sexo,departamento{extension},ciudad{nombre},profesiones{id nombre},institucion{nombre,abreviatura},pais{id nombre},estado,domicilio,fecha_nac,est_civil},asesor{id,telefono1,num_doc,nombres,pri_apellido,seg_apellido}, estado_academico{id, nro, nombre},canal{nombre}}}}`;
      vue.msg = '';
      //window.console.log( ">",sql );
      var inscritos = 0;
      var preinscritos = 0;
      var otros = 0;
      //let myHeaders = getheadersrest();
      //const requestOptions = { method: 'GET', headers: myHeaders, redirect: 'follow' };

      this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          vue.universidad = data.data.getPrograma.universidad;
          var sede = vue.programita.sede;
          //var sede = data.data.getPrograma.sede;
          //window.console.log('INSSSS:',data.data.getPrograma);
          vue.isSedePermitida(sede.id);
          var dts = data.data.getPrograma.inscripciones;
          //window.console.log(JSON.stringify(dts,null,4));
          dts.sort(function (a, b) {
            if (!a.estudiante) a.estudiante = {};
            return ('' + a.estudiante.pri_apellido).localeCompare(b.estudiante.pri_apellido);
          });

          vue.convenio = vue.universidad ? vue.universidad.convenio : false;
          vue.asesores = [];
          dts.forEach(function (e) {
            if (!e.xestado_titulacion) e.xestado_titulacion = null;
            // if(!e.xestado_ins_universidad) e.xestado_ins_universidad = null;
            let estadotit = vue.estados_titulacion.find((et) => et.id == e.idestadotitulacion);
            const isuniv = e.inscrito_universidad ? 1 : 2;
            const isModular = e.is_modular ? 1 : 2;
            const ide = e.estado_academico ? e.estado_academico.id : null;
            let estadoacad = vue.treeData.find((et) => et.id == ide);
            let estadouni = vue.estados_ins_universidad.find((u) => u.id == isuniv);
            let estadoModular = vue.estados_is_modular.find((m) => m.id == isModular);
            e.xestado_titulacion = estadotit;
            e.xestado_ins_universidad = estadouni;
            e.xestado_is_modular = estadoModular;
            e.xestado_academico = estadoacad;
            //window.console.log(">>",isuniv,estadouni);

            e.loadinddeta = false;
            if (!e.certificado_id) e.certificado_id = 0;
            e.estado_persona = e.estudiante.estado;
            if (e.estado_ins == 0) preinscritos += 1;
            else if (e.estado_ins == 1) inscritos += 1;
            else if (e.estado_ins > 1) otros += 1;

            if (!e.asesor) e.asesor = {};

            let asesor = vue.asesores.find((x) => x.num_doc == e.asesor.num_doc);
            if (!asesor) vue.asesores.push({ num_doc: e.asesor.num_doc, nombre: vue.parseEstudiante(e.asesor) });

            //window.console.log( "ESTU >>>> ",e.asesor )
            /*if (e.estado_ins == 1) {
              let urldeuda = process.env.VUE_APP_API_REST + `/api/esam/inscripcion/estudiante/id/${e.estudiante.id}/nopagados`;
              vue.idsinscritos.push(
                fetch(urldeuda, requestOptions).then((value) => value.json())
              );
            }*/
          });
          vue.inscripciones = dts;
          window.console.log(">>dts", dts);

          //this.msg = this.inscripciones.length+' inscripciones.';
          this.msg =
            '<span class="text-success"> Total inscritos:</span> ' +
            inscritos +
            ', <span class="text-danger">preinscritos:</span> ' +
            preinscritos +
            ', <span class="text-warning">Otros:</span> ' +
            otros;
          let contraer = window.sessionStorage.getItem('xcontraercolumnas');
          if (!contraer) vue.contraercolumnas = true;
          else if (contraer == 'true') vue.contraercolumnas = true;
          else vue.contraercolumnas = true;

          this.$refs.xalertar.reset();
          this.getCorreos(sede.id);
          //this.ejecutarpromesas();
        })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
          this.$notify(parseJsonError(error, 'getPrograma'));
        });
    },
    obtenertokensfcmfordeudas() {
      const fortokens = [];
      const vue = this;

      this.deudas.forEach(function (e) {
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        let sql = `query{ tokenEsamByuid(uid:"${e.estudiante_id}-"){ id,uid,token,data,fecha,estado } }`;
        var graphql = JSON.stringify({ query: sql, variables: {} });
        var requestOptions = { method: 'POST', headers: myHeaders, body: graphql };

        fortokens.push(
          fetch(process.env.VUE_APP_API_SLADIA + '/graphql/', requestOptions)
            .then((value) => value.json())
            .catch(() => {
              // window.console.log('error', error);
            }),
        );
      });

      Promise.all(fortokens)
        .then((allResponses) => {
          allResponses.forEach(function (res, ind) {
            let dts = res.data.tokenEsamByuid;
            dts.forEach(function (e) {
              e.activo = true;
              e.status = '-';
            });
            vue.deudas[ind].tokens = dts;
          });
          // window.console.log('allResponses',allResponses,vue.deudas);
        })
        .catch(() => {
          // window.console.log('error', error);
        });
    },
    limpiarRepetidos() { },
    getCorreos(idsede) {
      var sql = gql`query{ getSede(id:${idsede}){id,nombre,correos{tipo direccion}} }`;
      //window.console.log( "GET SEDEX: ",sql )
      this.$apollo
        .query({
          query: sql,
        })
        .then((data) => {
          this.sede = data.data.getSede;
          //window.console.log( "SEDEX: ",this.sede )
        })
        .catch((error) => {
          this.msg = error;
          window.console.error(error);
          this.$notify(parseJsonError(error, 'getSede'));
        });
    },
    getProfesion(profs) {
      if (!profs || profs.length == 0) return '-';
      var p = profs[0];
      return p.nombre;
    },
    getProfesiones(est) {
      if (!est.profesiones) return [];
      return est.profesiones;
    },
    getObservacion(ob) {
      if (!ob) return '';
      return ob;
    },
    getInstitucion(inst) {
      if (!inst) return '-';
      return inst.abreviatura + ' - ' + inst.nombre;
    },
    getGenero(est) {
      if (!est) return '-';
      return est.sexo;
    },

    numberWithCommas(x) {
      if (x == null) return '0';
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    myFunction1(filtro) {
      window.sessionStorage.setItem('xfind_ins', filtro);
      filtro = filtro.toUpperCase();
      var table, tr, tdd, td, i, j, txtValue;
      table = document.getElementById('midatatable');
      tr = table.getElementsByTagName('tr');
      var size = 0;
      for (i = 0; i < tr.length; i++) {
        tdd = tr[i].getElementsByTagName('td');
        for (j = 1; j < tdd.length; j++) {
          td = tdd[j];
          if (td) {
            txtValue = td.textContent;
            let condicion = txtValue.toUpperCase().trim().indexOf(filtro) > -1;
            if (filtro == 'INSCRITO') condicion = txtValue.toUpperCase().trim() == filtro.toUpperCase();
            //window.console.log('>>>', txtValue);
            // if (txtValue.toUpperCase().trim() == filtro.toUpperCase() ) {
            if (condicion) {
              tr[i].style.display = '';
              size++;
              break;
            } else {
              tr[i].style.display = 'none';
            }
          }
        }
      }
      this.filtro_size = size;
      //window.console.log( '>>>',size );
    },
    viewDetailStudent(ins) {
      ins.loadinddeta = true; // agregafo aqui
      this.$refs.refDetailIns.showThisView(ins.estudiante.id, ins.id, ins);
    },
    viewSolicitudCertificado(ins) {
      ins.loadinddeta = true; // agregafo aqui
      this.$refs.refSolicitudCertificado.showThisView(ins.estudiante.id, ins.id, ins);
    },
    cambiarestadoins(ins) {
      if (this.$store.state.CARGO.id == 1) {
        // window.console.log(ins);
        this.$refs.inscripcionestado.openmodal(ins);
      }
    },
    cambiarestadoAdministrativo(ins) {
      if (this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 3) {
        // window.console.log(ins);
        this.$refs.inscripcionestadoadmin.openmodal(ins);
      }
    },
    isdnasupervisor() {
      const idd = this.$store.state.CARGO.id;
      const isdna = idd == 6 || idd == 7 || idd == 23 || idd == 17 || idd == 20 || idd == 1; // coord. acad
      if (!isdna) return false;


      return this.$store.state.DATA_USER.id == 19467 || this.$store.state.DATA_USER.id == 59716 || this.$store.state.DATA_USER.id == 32182; // supervisores dna
    },
    async mounted() {
      const idd = this.$store.state.CARGO.id;
      this.isdna = idd == 6 || idd == 7 || idd == 23 || idd == 17 || idd == 20 || idd == 1; // coord. acad


      await this.llenarEstadosTitulacion();
      await this.llenarEstadosInsUniversidad();
      await this.getEstadosAcademicos();

      this.llenadotextodefecto();
      xaxios.get(`${this.api_rest}/esam/programa/id/${this.programa.id}`).then(({ data }) => {
        this.programa_rest = data;
        this.listadoprog();
      });
      this.programita = this.programa;
      // window.console.log('////', this.programita);
      this.isuser();
      this.categoria_id = this.programita.postgrado.categoria.id;
      this.sede_certificado = this.programa.sede.id == this.$store.state.CARGO.idsede;
      this.pro = this.parsePrograma(this.programa);
      this.idprograma = this.programa.id;
      this.validarDatos();

      const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
      const comparer = (idx, asc) => (a, b) =>
        ((v1, v2) => (v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)))(
          getCellValue(asc ? a : b, idx),
          getCellValue(asc ? b : a, idx),
        );
      document.querySelectorAll('th').forEach((th) =>
        th.addEventListener('click', () => {
          const table = th.closest('table');
          const tbody = table.querySelector('tbody');
          Array.from(tbody.querySelectorAll('tr'))
            .sort(comparer(Array.from(th.parentNode.children).indexOf(th), (this.asc = !this.asc)))
            .forEach((tr, ind) => {
              tr.firstChild.innerHTML = ind + 1;
              tbody.appendChild(tr);
            });
        }),
      );
    },
    changeProgramaView(ins) {
      this.$refs.refChangeProgramaIns.showThisView(ins.id);
    },
    editarplanpagos(ins) {
      //this.$refs.editarplanpagos.getinscripcionx(ins.id);
      //window.console.log(this.programita);
      this.$router.push({
        name: 'editarplanpagos',
        params: { idprograma: this.programita.id, idpersona: ins.estudiante.id, idinscripcion: ins.id },
      });
    },
    agregarConcepto(ins) {
      //this.$refs.editarplanpagos.getinscripcionx(ins.id);
      //window.console.log(this.programita);
      this.$router.push({
        name: 'agregarconcepto',
        params: { idprograma: this.programita.id, idpersona: ins.estudiante.id, idinscripcion: ins.id },
      });
    },

    llenadotextodefecto() {
      var us = this.$store.state.DATA_USER;
      if (us.seg_apellido == null) us.seg_apellido = '';
      var user = us.nombres + ' ' + us.pri_apellido + ' ' + us.seg_apellido;
      this.modalws.texto = `Soy la Lic. ${user}, seré la persona que le va a colaborar en todo el proceso desde el area economica financiera.`;
    },
    listadoprog() {
      let inicio = new Date(this.programa_rest.fecha_inicio);
      let hoy = new Date('2021-11-01'); // inicio de los contratos.
      //window.console.log('GET PROG:', this.programa_rest,'\n\n', inicio, hoy);
      //window.console.log('FECHAS:> ', inicio.getTime() >= hoy.getTime() );
      this.isvalidogencontrato = inicio.getTime() >= hoy.getTime();
      this.verificar_is_upi();
    },
    isuser() {
      let cargo = this.$store.state.CARGO;
      if (!cargo) return;
      if (!this.programita) return;
      this.is_user_of_sede = cargo.idsede == this.programita.sede.id;
      // window.console.log(cargo.idsede, this.programita.sede.id);
    },
    async llenarEstadosTitulacion() {
      const res = await getEstadosTitulacion(this);
      // window.console.log('loggg', res);
      res.forEach((e) => {
        this.estados_titulacion.push({ id: e.id, text: e.nombre, color: e.color });
      });
    },
    llenarEstadosInsUniversidad() {
      this.estados_ins_universidad.push({ id: 1, text: 'SI', color: 'green' });
      this.estados_ins_universidad.push({ id: 2, text: 'NO', color: 'red' });
    },
    llenarIsModular() {
      this.estados_is_modular.push({ id: 1, text: 'SI', color: 'green' });
      this.estados_is_modular.push({ id: 2, text: 'NO', color: 'red' });
    },


    async guardarEstadoAcademico(ins) {
      window.console.log('insssss', ins);
      const estid = ins.xestado_academico ? ins.xestado_academico.id : null;
      if (!estid) return;
      const sql = gql` 
        mutation{
          cambioEstadoAcademico(input:{inscripcion_id:${ins.id},nuevo_estado:${estid}}){ok errors{message}}
        }
      `;
      const r = await this.$apollo.mutate({ mutation: sql }).then(({ data }) => data).catch(e => e);
      if (r && r.cambioEstadoAcademico) {
        window.console.log('cambioEstadoAcademico', r.cambioEstadoAcademico)
        if (r.cambioEstadoAcademico.ok) {
          this.$root.$notify.show('Estado asignado', { color: 'green', x: 'right' });
        } else {
          this.$root.$notify.show('Estado NO asignado', { color: 'red', x: 'right' });
        }
      }
    },
    async guardarEstadoTitulacion(ins) {
      const idinscripcion = ins.id;
      const idestado = ins.xestado_titulacion.id;

      const res = await setEstadoTitulacion(this, idinscripcion, idestado);
      if (res.ok) {
        this.$root.$notify.show('Estado asignado correctamente', { color: 'green', x: 'right' });
      } else if (res.errors) {
        const er = res.errors[0].message;
        this.$root.$notify.show(er, { color: 'red', x: 'right' });
      } else {
        window.console.log(res);
      }
    },
    async guardarEstadoInsUniversidad(ins) {
      const idinscripcion = ins.id;
      const idestado = ins.xestado_ins_universidad.id == 1;
      // window.console.log('>>', ins, idestado);
      const res = await setEstadoInscritoUniv(this, idinscripcion, idestado);
      if (res.ok) {
        this.$root.$notify.show('Estado asignado correctamente', { color: 'green', x: 'right' });
      } else if (res.errors) {
        const er = res.errors[0].message;
        this.$root.$notify.show(er, { color: 'red', x: 'right' });
      } else {
        window.console.log(res);
      }
    },
    async guardarEstadoIsModular(ins) {
      const idinscripcion = ins.id;

      const idestado = ins.xestado_is_modular.id == 1;

      const res = await setEstadoIsModular(this, idinscripcion, idestado);
      if (res.ok) {
        this.$root.$notify.show('Estado asignado correctamente', { color: 'green', x: 'right' });
      } else if (res.errors) {
        const er = res.errors[0].message;
        this.$root.$notify.show(er, { color: 'red', x: 'right' });
      } else {
        window.console.log(res);
      }
    },

    async getEstadosAcademicos() {
      const sql = gql`query{ getEstadosAcademicos{ id nro nombre descripcion estado_academico_padre_id }}`;
      const r = await this.$apollo.query({ query: sql }).then(({ data }) => data).catch(e => e);
      if (r && r.getEstadosAcademicos) {
        const d = r.getEstadosAcademicos;
        d.forEach(x => {
          x.color = '#000000'
        })
        this.estados_academicos = d;
        window.console.log('programa', this.programa);

        const quitado = await this.quitarEstadosDiplomado();
        //const quitado2 = await this.quitarEstados(quitado);
        window.console.log('quitado', quitado);
        const estadosSinDBS = await this.quitarEstadosDbs(quitado);
        window.console.log('estados DBS', estadosSinDBS);
        const tree = await this.buildTree(estadosSinDBS);

        //this.groupedData = this.buildGroupedData(d);
        this.treeData = this.flattenTree(tree);
        window.console.log('treeData', this.treeData);

      }
    },
    quitarEstadosDiplomado() {
      if (this.programa.nombre_compuesto.toLowerCase().includes('diplomado')) {
        return this.estados_academicos.filter(x => (x.nro != '1.3.2.2' && x.nro != '1.3.2.3'));
      }
      return this.estados_academicos;
    },
    quitarEstados(estado_academicos) {
      const excluir = [
        "1.3", "1.4", "1.3.1", "1.3.2", "1.3.2.1", "1.3.2.2", "1.3.2.3",
        "2.1", "2.3", "2.3.1", "2.3.2"
      ];
      return estado_academicos.filter(
        x => !excluir.includes(x.nro.toLowerCase())
      );
    },
    quitarEstadosDbs(estados_academicos) {
      if (this.programa.sede.unidad_negocio == 10) {
        return estados_academicos.filter(x => !x.nro.toLowerCase().startsWith('2.3'));
      }
      return estados_academicos;
    },
    abrirModalSolicitud() {
      this.modalSolicitud = true
    },
    cerrarModalSolicitud() {
      this.modalSolicitud = false
    },

    flattenTree(tree, level = 0) {
      let flatList = [];
      tree.forEach((node) => {
        const excluir = [
          "1.3", "1.4", "1.3.1", "1.3.2", "1.3.2.1", "1.3.2.2", "1.3.2.3",
          "2.1", "2.3", "2.3.1", "2.3.2"
        ];
        const disabled = excluir.includes(node.nro) || !(node.children.length === 0);
        //const visible=excluir.includes(node.nro)?false:true;
        flatList.push({ ...node, level, selectable: node.children.length === 0, disabled: disabled, hidden: true });
        if (node.children) {
          flatList = flatList.concat(this.flattenTree(node.children, level + 1));
        }
      });
      return flatList;
    },
    buildTree(data, parentId = null, parentNombre = null, level = 0) {
      window.console.log('buildTree', data, parentId, level);
      return data
        .filter((item) => item.estado_academico_padre_id === parentId)
        .map((item) => ({
          id: item.id,
          nro: item.nro,
          nombre: item.nombre,
          nombre_padre: parentNombre ? parentNombre : item.nombre,
          level, // Nivel de anidación para aplicar margen
          children: this.buildTree(data, item.id, parentNombre === null ? item.nombre : parentNombre + " / " + item.nombre, level + 1),
        }));
    },
    buildGroupedData(data) {
      const groupedData = [];
      const parents = data.filter((item) => !item.estado_academico_padre_id);

      parents.forEach((parent) => {
        groupedData.push({
          header: parent.nombre,
          children: data
            .filter((item) => item.estado_academico_padre_id === parent.id)
            .map((child) => ({
              id: child.id,
              nombre: child.nombre,
            })),
        });
      });

      return groupedData;
    },
    verificar_is_upi() {
      const e = (window.location.href + '')
      window.console.log('SEDE::::', this.programa, e);

      // if((e.includes('localhost') || e.includes('webdev')) && this.programa.universidad_id == 301 ){
      if (this.programa.universidad.id == 301) {
        this.is_upi = true
      }
    },
    open_duplicar_in_q10(ins) {
      // window.console.log('this.programa',this.programa, ins);
      const p = Object.assign({}, this.programa);
      p.programa_id = p.id
      this.$refs.refmodal_propuesta_duplicar.openmodal(p, ins.estudiante)
    },
    onEstadoCambiadoAdministrativo(resultado) {
      if (resultado.success) {
        // Mostrar mensaje de éxito
        // this.$toast.success(resultado.message);
        window.console.log('Resultado cambio estado administrativo:', resultado);
        this.$root.$notify.show('Estado actualizado correctamente', { color: 'green', x: 'right' });
        // Actualizar datos en el padre si es necesario
        this.actualizarEstadoInscripcion(
          resultado.inscripcionId,
          resultado.estadoNuevo
        );
      } else {
        // Mostrar mensaje de error
        //this.$toast.error(resultado.message);
        this.$root.$notify.show('Error al actualizar el estado', { color: 'red', x: 'right' });

      }
    },
    actualizarEstadoInscripcion(id, nuevoEstado) {
      // Aquí actualizas la lista de inscripciones en el padre
      window.console.log('Actualizar estado de inscripcion:', id, nuevoEstado);

      const index = this.inscripciones.findIndex(i => i.id === id);
      if (index !== -1) {
        this.inscripciones[index].estado_administrativo_id = nuevoEstado;
        // Puedes agregar más lógica según necesites
      }
    },

  },
  async mounted() {
    const idd = this.$store.state.CARGO.id;
    const userid = this.$store.state.DATA_USER.id;
    this.isdna = idd == 6 || idd == 7 || idd == 23 || idd == 17 || idd == 20 || idd == 1; // coord. acad

    await this.llenarEstadosTitulacion();
    await this.llenarEstadosInsUniversidad();
    await this.llenarIsModular();
    await this.getEstadosAcademicos();
    window.console.log('loggg', this.estados_academicos);
    window.console.log("treee", this.treeData);

    // yamilet sarmiento
    // diana santiago
    // rubi rodriguez 
    // claudia escobar 
    // fanny ortiz
    // alejandra canaviri
    // lenardo troya
    // diana cossio
    if (userid == 43 || userid == 137074 || userid == 137072 || userid == 139801 || userid == 65958 || userid == 30820 || userid == 8920 || userid == 26164 || userid == 136449 || userid == 34099) {
      this.permit_migrar_upi = true
    }


    this.llenadotextodefecto();
    xaxios.get(`${this.api_rest}/esam/programa/id/${this.programa.id}`).then(({ data }) => {
      this.programa_rest = data;
      this.listadoprog();
    });
    this.programita = this.programa;
    const name = this.programa.nombre_compuesto.toLowerCase();
    this.isgoup = name.includes(' goup ');
    this.iscca = this.$store.state.CARGO.sede.unidad_negocio == 2;

    // window.console.log('HOLALA', this.programa, this.isgoup);
    this.isuser();
    this.categoria_id = this.programita.postgrado.categoria.id;
    this.sede_certificado = this.programa.sede.id == this.$store.state.CARGO.idsede;
    this.pro = this.parsePrograma(this.programa);
    this.idprograma = this.programa.id;
    this.validarDatos();


    const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
    const comparer = (idx, asc) => (a, b) =>
      ((v1, v2) => (v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)))(
        getCellValue(asc ? a : b, idx),
        getCellValue(asc ? b : a, idx),
      );
    document.querySelectorAll('th').forEach((th) =>
      th.addEventListener('click', () => {
        const table = th.closest('table');
        const tbody = table.querySelector('tbody');
        Array.from(tbody.querySelectorAll('tr'))
          .sort(comparer(Array.from(th.parentNode.children).indexOf(th), (this.asc = !this.asc)))
          .forEach((tr, ind) => {
            tr.firstChild.innerHTML = ind + 1;
            tbody.appendChild(tr);
          });
      }),
    );
  },
};
</script>
<style lang="css">
.tablita th {
  cursor: pointer;
}

.tablita th,
.tablita td {
  white-space: inherit !important;
}

.first-col {
  position: absolute;
  width: 5em;
  padding-top: 10px;
  margin-left: 0em;
}

.second-col {
  padding-left: 3em !important;
}

.custom-select .vs__dropdown-menu {
  min-width: max-content;
  /* Ajusta el ancho al contenido más largo */
  white-space: nowrap;
  /* Evita que el texto se divida en varias líneas */
  position: absolute;
  z-index: 10001;
  top: 100%;
  /* Asegura que esté justo debajo del select */
  left: 0;
}

.v-list-item--disabled {
  pointer-events: stroke;
}
</style>
